import { baseUrls } from '@monorepo/common';

export const getJobsAccountLoginUrl = (returnUrl: string): string => (
  `${baseUrls.login}?returnUrl=${encodeURIComponent(returnUrl)}`
);

export const getJobsAccountLogoutUrl = (returnUrl: string): string => (
  `${baseUrls.login}/logout?returnUrl=${encodeURIComponent(returnUrl)}`
);
